import { render, staticRenderFns } from "./IconCounter.vue?vue&type=template&id=109283c9"
import script from "./IconCounter.vue?vue&type=script&lang=js"
export * from "./IconCounter.vue?vue&type=script&lang=js"
import style0 from "./IconCounter.vue?vue&type=style&index=0&id=109283c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports